import Box from '@material-ui/core/Box';
import AppBar from '@material-ui/core/AppBar';
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import { useHistory, useLocation } from 'react-router';
import Grid from '@material-ui/core/Grid';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { useFakeRole } from 'AppCtx';
import { TextField } from '@material-ui/core';
import { getTheme } from '../../theme';
import Logo from './Logo';
import AccountMenu from './app-header/AccountMenu';
import { realRoleNames } from '../../cassandra-shared-js/roles';
import { useAuth } from '../../AuthCtx';

const useStyles = makeStyles((theme) => {
  return {
    appBar: {
      height: theme.layout.topBarHeight,
      boxShadow: 'unset',
      backgroundColor: 'unset',
      flexDirection: 'row',
      zIndex: theme.zIndex.drawer + 1,
    },
    topBar: {
      display: 'flex',
      flexGrow: 1,
      height: theme.layout.topBarHeight - 1,
      padding: theme.spacing(0, 3),
      backgroundColor: 'white',
      boxShadow: 'rgb(40, 42, 49, 16%) 0px 1px 2px 0px',
    },
    backButton: {
      borderRadius: 0,
      marginLeft: -theme.spacing(3), // negative margin to cancel out the layout's padding
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),
      backgroundColor: theme.palette.alternate.main,
      height: '100%',
    },
  };
});

const BackButton = () => {
  const history = useHistory();
  const location = useLocation();
  const classes = useStyles();

  if ('' === location.search) { return null; }
  return (
    <Button
      className={ classes.backButton }
      disableRipple
      disableElevation
      variant='contained'
      onClick={ () => {
        return history.go(-1);
      } }
    >
      <ArrowBackIosIcon style={ { marginRight: getTheme().spacing(1) } } />
      GO BACK
    </Button>
  );
};

function AdminRoleSelection() {
  const rolesOptions = Object.values(realRoleNames).filter((val) => {
    return true !== val.hidden;
  });

  const { fakeRole, setFakeRole } = useFakeRole();
  const { user } = useAuth();

  if (!user || user.role.name.toLowerCase() !== realRoleNames.ADMINISTRATOR_ROLE.value.toLowerCase()) {
    return null;
  }

  return (
    <Autocomplete
      style={ { width: 300, position: 'relative', top: '5px' } }
      id='Admin-fake-roles'
      options={ rolesOptions }
      getOptionLabel={ (option) => { return option?.name ?? ''; } }
      onChange={ (event, newValue) => {
        setFakeRole(newValue);
      } }
      value={ fakeRole }
      renderInput={ (params) => {
        const val = fakeRole?.name ?? '';
        return (
          <TextField
            value={ val }
            { ...params }
            label='Select a role'
            variant='outlined'
            placeholder='Roles'
          />
        );
      } }
    />
  );
}

const AppHeader = () => {
  const classes = useStyles();
  return (
    <AppBar position='fixed' className={ classes.appBar }>
      <Logo />
      <Box className={ classes.topBar }>
        <Grid style={ { height: '100%' } } container direction='row' justify='space-between'>
          <Grid item>
            <BackButton />
          </Grid>
          <Grid>
            <AdminRoleSelection />
          </Grid>
          <Grid item>
            <AccountMenu />
          </Grid>
        </Grid>
      </Box>
    </AppBar>
  );
};

export default AppHeader;
